import React from 'react';

import SearchIcon from 'mdi-react/MagnifyIcon';
import * as S from './styles';

type SearchProps = {
  onChange: (value: string) => void;
  onSearch: (search: string) => void;
  hasResults?: boolean;
  placeholder?: string;
};

const Search = ({
  onChange,
  onSearch,
  hasResults,
  placeholder,
}: SearchProps) => {
  const [state, setState] = React.useState({ search: '' });
  const { search } = state;

  const clearInput = React.useCallback(() => {
    onChange('');
    setState({ search: '' });
  }, [onChange]);

  const onSearchButtonClick = React.useCallback(() => {
    onSearch(state.search);
  }, [onSearch, state.search]);

  const onInputChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void = React.useCallback(
    ({ target }) => {
      onChange(target.value);
      setState({ search: target.value });
    },
    [onChange]
  );

  return (
    <S.Block hasResults={hasResults}>
      <S.Input
        onChange={onInputChange}
        type="text"
        value={search}
        placeholder={placeholder}
      />
      <S.ClearButton type="button" visible={search} onClick={clearInput}>
        <S.CloseIcon size={20} />
      </S.ClearButton>
      <S.FullSearchButton type="button" onClick={onSearchButtonClick}>
        <SearchIcon />
      </S.FullSearchButton>
    </S.Block>
  );
};

Search.defaultProps = {
  onChange: () => {},
  onSearch: () => {},
  hasResults: false,
  placeholder: undefined,
};

export default Search;
